module.exports = __webpack_public_path__ + "static/media/slide3.4afe33ba.png";